import React from 'react';
import './styles.less';
import Icon from './ns.png';

const StandIcon = () => {
	return <img className="stand-icon" src={Icon} alt="Наш Север" />;
};

export { StandIcon };
